export default "__VITE_ASSET__DDjE$V6W__"